import { ImageChartComponent } from './image-chart';

export { ImageChartComponent };
